<template>
  <div class="book-filters__content">
    <div class="book-filters__content-head">
      <r-text colorType="subhead">
        {{ $t("book-filters:info") }}
      </r-text>
    </div>

    <div class="book-filters__content-row">
      <r-text colorType="subhead">{{ $t("book-filters:name") }}</r-text>
      <el-input
        class="r-input"
        size="mini"
        :placeholder="$t('book-filters:name-placeholder')"
        v-model="filterName"
      ></el-input>
    </div>

    <div class="book-filters__content-row">
      <r-text colorType="subhead">{{ $t("book-filters:attribute") }}</r-text>
      <el-select
        class="r-select"
        v-model="attrValue"
        :placeholder="$t('book-filters:attribute-placeholder')"
        @change="attrHandleChange"
        filterable
        clearable
        size="mini"
      >
        <el-option
          v-for="item in activeFields"
          :key="item.title"
          :label="item.title"
          :value="item.title"
        >
        </el-option>
      </el-select>
    </div>
    <div class="book-filters__content-row" v-if="attrValue">
      <r-text colorType="subhead">{{ $t("book-filters:type") }}</r-text>
      <el-select
        class="r-select"
        v-if="attrValue"
        v-model="filterType"
        :placeholder="$t('book-filters:type-placeholder')"
        size="mini"
        filterable
        clearable
      >
        <el-option
          v-for="item in searchTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="book-filters__content-row" v-if="filterType === 'between'">
      <r-text colorType="subhead">{{ $t("book-filters:value") }}</r-text>
      <el-row type="flex" class="r-row">
        <el-input
          class="r-input"
          size="mini"
          :placeholder="$t('book-filters:value-from-placeholder')"
          v-model="inputFrom"
        ></el-input>
        <el-input
          class="r-input"
          size="mini"
          :placeholder="$t('book-filters:value-to-placeholder')"
          v-model="inputTo"
        ></el-input
      ></el-row>
    </div>
    <div
      class="book-filters__content-row"
      v-else-if="filterType && filterType !== '!null'"
    >
      <r-text colorType="subhead">{{ $t("book-filters:value") }}</r-text>
      <el-input
        class="r-input"
        size="mini"
        :placeholder="$t('book-filters:value-placeholder')"
        v-model="inputFrom"
      ></el-input>
    </div>
    <div class="book-filters__content-row right">
      <el-button class="r-button simple" @click="closeFilter">
        {{ $t("book-filters:cancel") }}</el-button
      >
      <el-button
        class="r-button"
        type="primary"
        @click="setTableFilter"
        :disabled="!isFilterValid"
        >{{ $t("book-filters:apply") }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { generateUUID, isEmpty } from "@/utils";
import { filterTypes } from "./filter-types.js";

export default {
  data() {
    return {
      active: true,
      filterId: "",
      filterName: "",
      attrValue: "",
      filterType: "",
      inputFrom: "",
      inputTo: "",
      searchTypes: []
    };
  },
  computed: {
    activeTableId() {
      return this.$store.state.book.activeTable.id;
    },
    activeFields() {
      return this.$store.state.book.activeFields.fields;
    },
    openFilter() {
      return this.$store.state.book.filters.openFilter;
    },
    existingFilters() {
      return this.$store.state.book.filters.filtersConfigs;
    },
    isFilterValid() {
      if (
        isEmpty(this.inputFrom) &&
        isEmpty(this.inputTo) &&
        this.filterType !== "!null"
      ) {
        return false;
      }
      return true;
    }
  },
  methods: {
    attrHandleChange(val) {
      this.filterType = "";
      this.inputFrom = "";
      this.inputTo = "";
      if (!val) {
        this.filterType = "";
        return;
      }
      this.setSearchTypes(val);
    },
    setSearchTypes(val) {
      let currentItem = this.activeFields.find(e => e.title === val);

      if (currentItem) {
        switch (currentItem.type) {
          case "integer":
          case "decimal":
          case "numeric":
          case "float":
          case "number":
          case "datetime":
          case "date":
          case "time":
            this.searchTypes = filterTypes.numeric;
            break;
          case "boolean":
            this.searchTypes = filterTypes.boolean;
            break;
          default:
            this.searchTypes = filterTypes.string;
            break;
        }
      }
    },
    async setTableFilter() {
      const filterValue =
        this.filterType === "between"
          ? `${this.inputFrom}/${this.inputTo}`
          : this.inputFrom;

      this.$store.commit("SET_TABLE_FILTER", {
        active: this.active,
        name: this.filterName,
        id: this.filterId,
        field: this.attrValue,
        op: this.filterType,
        type: "AND",
        value: filterValue,
        update: true
      });
      await this.$store.dispatch("SAVE_MODULE_USER_CONFIG", {
        module: "book",
        id: this.activeTableId
      });
      this.$store.commit("UPDATE_ACTIVE_TABLE");
      this.$store.commit("CLOSE_MODAL_WINDOW", "");
    },
    closeFilter() {
      this.$store.commit("CLOSE_MODAL_WINDOW", "");
    }
  },
  mounted() {
    if (this.openFilter !== "new") {
      const currentFilter = this.existingFilters.filter(
        e => e.id === this.openFilter
      );

      this.filterId = currentFilter[0].id;
      this.attrValue = currentFilter[0].field;
      this.filterType = currentFilter[0].op;
      this.inputFrom = currentFilter[0].value.split("/")[0];
      this.inputTo = currentFilter[0].value.split("/")[1];
      this.filterName = currentFilter[0].name;
      this.active = currentFilter[0].active;
      this.searchTypes = [];
      this.setSearchTypes(currentFilter[0].field);
    } else {
      this.filterId = generateUUID();
      this.attrValue = "";
      this.filterType = "";
      this.inputFrom = "";
      this.inputTo = "";
      this.searchTypes = [];
      this.active = true;

      this.filterName = `${this.$t("book-filters:default-name")} ${this
        .existingFilters.length + 1}`;
    }
  }
};
</script>

<style lang="scss">
.book-filters__content {
  max-height: calc(100vh - 548px);
  min-height: calc(200px);
  overflow: auto;
  overflow-x: hidden;
  input,
  .r-select {
    width: 100%;
  }
  &-head {
    margin-bottom: 24px;
    word-break: normal;
  }
  &-row {
    margin-top: 16px;
    &:first-child {
      margin-top: 0;
    }
    &.right {
      text-align: right;
    }
    .r-row {
      .r-input {
        &:nth-child(even) {
          padding-left: 5px;
        }
        &:nth-child(odd) {
          padding-right: 5px;
        }
      }
    }
  }
  .r-text {
    margin-bottom: 8px;
  }
}
</style>

<i18n>
{
  "ru": {
    "book-filters:info": "Выберите необходимые значения для фильтрации объектов",
    "book-filters:name": "Название",
    "book-filters:name-placeholder": "Название фильтра",
    "book-filters:attribute": "По какому атрибуту фильтровать",
    "book-filters:attribute-placeholder": "Не выбран",
    "book-filters:type": "Тип фильтра",
    "book-filters:type-placeholder": "Не выбран",
    "book-filters:value": "Критерий или значение",
    "book-filters:value-placeholder": "Введите критерий или значение",
    "book-filters:value-from-placeholder": "От",
    "book-filters:value-to-placeholder": "До",
    "book-filters:default-name": "Фильтр",

    "book-filters:cancel": "Отмена",
    "book-filters:apply": "Создать фильтр"
  },
  "en": {
    "book-filters:info": "Select the required values to filter objects",
    "book-filters:name": "Enter filter name",
    "book-filters:name-placeholder": "Name",
    "book-filters:attribute": "Select attribute",
    "book-filters:attribute-placeholder": "Attribute",
    "book-filters:type": "Select filter type",
    "book-filters:type-placeholder": "Type",
    "book-filters:value": "Enter value",
    "book-filters:value-placeholder": "Value",
    "book-filters:value-from-placeholder": "From",
    "book-filters:value-to-placeholder": "To",
    "book-filters:default-name": "Filter",

    "book-filters:cancel": "Cancel",
    "book-filters:apply": "Create filter"
  }
}
</i18n>
